import React from 'react';

import { MenuItem, TextField } from '@mui/material';

export default function ScopeSelect({
  label,
  value,
  values,
  onChange,
}: {
  label: string;
  value: string;
  values: Array<string>;
  onChange: (value: string) => void;
}) {
  const options = values.includes(value) ? values : [value, ...values];
  return (
    <TextField select fullWidth size="small" label={label} value={value} onChange={(e) => onChange(e.target.value)}>
      {options.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
  );
}
